export enum PINS {
  ROCKET = "rocket",
}
